import { styled } from '@mui/material/styles';
import { GridToolbar, GridToolbarQuickFilter as MuiGridToolbarQuickFilter } from '@mui/x-data-grid-premium';
import { Box } from '@coolblue-development/freddy';

const GridToolbarQuickFilter = styled(MuiGridToolbarQuickFilter)({
  svg: { fill: '#999999', flexShrink: 0 }
});

export const AgentsDashboardToolbar = (): JSX.Element => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1 }}>
      <GridToolbar sx={{ marginRight: 'auto', gap: '15px' }} />
      <GridToolbarQuickFilter
        size="small"
        autoFocus
        debounceMs={1000}
        quickFilterParser={(searchInput: string) =>
          searchInput
            .split(',')
            .map(value => value.trim())
            .filter(value => value !== '')
        }
      />
    </Box>
  );
};
